"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.featureMap={rotation:{sdk:"5.5.0",name:"Rotation by features"}};